// extracted by mini-css-extract-plugin
export default {"drink_img":"ProductDrink_drink_img__A-90S"};